import { apiClient } from './client';
export const googleAuthApi = {
    /** Get the OAuth authorization URL to open in popup */
    initiate: async () => {
        return apiClient.get('/api/Auth/Google/Initiate');
    },
    /** Check if user has connected their Google account */
    getStatus: async () => {
        return apiClient.get('/api/Auth/Google/Status');
    },
    /** Get a fresh access token and Picker API key for the Google Picker */
    getPickerToken: async () => {
        return apiClient.get('/api/Auth/Google/PickerToken');
    },
    /** Disconnect the user's Google account */
    disconnect: async () => {
        return apiClient.delete('/api/Auth/Google/Disconnect');
    },
};
